import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import LanguageWrapper from './components/LanguageWrapper';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <LanguageWrapper>
    <App></App>
  </LanguageWrapper>
);

reportWebVitals();